export default "__VITE_ASSET__C1RKydk7__"